<template>
  <div id="app">
    <router-view />

    <PreSource
      ref="preSourceBox"
      :visible="visible"
      :url="sourceUrl"
      :type="sourceType"
    />
  </div>
</template>

<style lang="scss">
//@import "@/assets/sass/minin.scss";
@import "@/assets/sass/base.scss";
</style>

<script>
import store from '@/store';
import PreSource from "@/components/PreSource.vue";
import { mapMutations } from "vuex";
export default {
  name: "app",
  components: {
    PreSource,
  },
  beforeCreate(){
     var userInfo = localStorage.getItem('userInfo');
     if(userInfo){
      store.commit('login', JSON.parse(userInfo))
    }
  },
  created() {
   
  },
  data() {
    return {
      visible: false,
      sourceUrl: "",
      sourceType: "",
    };
  },
  methods: {
    preSource(sourceUrl, sourceType) {
      this.$refs.preSourceBox.show(sourceUrl, sourceType);
    },
    ...mapMutations(["login", "signOut"]),

  },
};
</script>
<style scoped>
 #app{height:100vh;overflow:auto;}
</style>